import { getMediaWithProxy, getVideoProxyfied } from '../../../utils';
import type {
  GalleryMediaValue,
  MediaValue,
  VideoMediaValue
} from '../../types';
import type { TiktokResponseItemType } from '../types';

type TiktokMediaValue = Extract<
  MediaValue,
  GalleryMediaValue | VideoMediaValue
>;

type GetTiktokMediaParams = Partial<TiktokResponseItemType> & {
  widgetToken: string;
};

export const getTiktokMedia = ({
  id,
  thumbnailURL,
  carousel,
  widgetToken,
  type = 'video'
}: GetTiktokMediaParams): TiktokMediaValue => {
  if (type === 'image' && carousel) {
    return {
      type: 'gallery',
      items: carousel.map(({ url }) => ({
        type: 'image',
        src: getMediaWithProxy(url)
      })),
      thumbnail: getMediaWithProxy(thumbnailURL)
    };
  }

  const rawSrc = `https://www.tiktok.com/embed/v2/${id}`;

  return {
    type: 'video',
    src: getVideoProxyfied(rawSrc, widgetToken),
    thumbnail: getMediaWithProxy(thumbnailURL)
  };
};
